// extracted by mini-css-extract-plugin
export default {"field":"AllocationLocationGroupsSelect_field__+jzVB"};